// smoothScroll.js

let animationId = null;

export function animateScrollTo(to, duration = 600) {
  if (animationId !== null) {
    cancelAnimationFrame(animationId);
    animationId = null;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    window.scrollTo(0, to);
    return;
  }

  const start = window.scrollY;
  const change = to - start;
  const startTime = performance.now();

  function animate(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = easeInOutQuad(progress);

    window.scrollTo(0, start + change * ease);

    if (progress < 1) {
      animationId = requestAnimationFrame(animate);
    } else {
      animationId = null;
    }
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  animationId = requestAnimationFrame(animate);
}

export function smoothScrollToHash(offset = 0, duration = 600) {
  const hash = window.location.hash;

  if (hash) {
    const target = document.getElementById(hash.substring(1));
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      animateScrollTo(top, duration);
    }
  }
}

export function setupAnchorLinks(offset = 0, duration = 600) {
  const anchorLinks = document.querySelectorAll('a[href*="#"]:not([href="#"])');

  anchorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const url = new URL(this.href, location.href);

      // 同一ページ内のハッシュリンクのみ対象
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      if (!url.hash) return;

      const target = document.getElementById(url.hash.substring(1));

      if (target) {
        e.preventDefault();

        const top =
          target.getBoundingClientRect().top + window.scrollY - offset;

        window.history.pushState(null, "", url.hash); // URLにハッシュを追加
        animateScrollTo(top, duration);
      }
    });
  });
}
